export default __webpack_public_path__ + "static/media/unity-game.8f91f0f0.png";